import BaseApiService from '@/services/api/base-api.service';
import OptionsChain from '@/models/markets/options-chain.model';
import AccountList from '@/models/accounts/account-list.model';
import UserProfile from '@/models/user-profile.model';
import { CONFIGURATIONS } from '@/utilities/configurations';
import AccessToken from '@/models/access-token.model';

export default class TradierService {
  accessToken = null;

  constructor(token) {
    if (!token) throw new Error('Token is required');
    if (!(token instanceof AccessToken)) throw new Error('Token must be an instance of AccessToken');

    this.accessToken = token;
    this.baseUrl = CONFIGURATIONS[token.environment].apiUrl;

    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.accessToken.token}`,
    };

    this._client = new BaseApiService({
      baseURL: this.baseUrl,
      headers,
    });
  }

  async lookupOptions(underlying) {
    if (!underlying) {
      throw new Error('Underlying is required');
    }
    return {
      response: {},
      chain: new OptionsChain(underlying, []),
    };
  }

  async fetchAccounts() {
    const { data } = await this._client.get('/v1/user/profile');
    return AccountList.fromJson(data);
  }

  async fetchProfile() {
    const { data } = await this._client.get('/v1/user/profile?withDetails=true');
    return UserProfile.fromJson(data);
  }
}
